import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <div className="logo-icon">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
              <circle cx="15" cy="15" r="8" fill="#FFB6C1" />
              <circle cx="25" cy="12" r="7" fill="#FFD700" />
              <circle cx="20" cy="22" r="6" fill="#87CEEB" />
            </svg>
          </div>
          <span className="logo-text">Book My Decoration</span>
        </div>
        
        <nav className="nav-menu">
          <a href="#home" className="nav-link">Home</a>
          <a href="#decorations" className="nav-link">Decorations</a>
          <a href="#about" className="nav-link">About</a>
          <a href="#services" className="nav-link">Services</a>
          <a href="#contact" className="nav-link">Contact Us</a>
        </nav>

        <a href="https://wa.me/9166007718" className="enquiry-btn" target="_blank" rel="noopener noreferrer">Enquiry Now</a>
      </div>
    </header>
  );
};

export default Header;
